

export interface CargoT {
  id: string
  category: string
  comments: string
  damage: string
  delivered: boolean
  index?: number
  item: string
  units: number
  volume: number
  // pounds?: number
}

export type CargoKeysT = keyof CargoT
export interface CargoPrintT extends CargoT {
  total: number
  pounds: number
}
export type CupeSheetPrintT = {
  category: string
  total: number
  items: Array<CargoPrintT>
}


export const CargoObj: CargoT = {
  id: '',
  category: '',
  comments: '',
  damage: '',
  delivered: false,
  item: '',
  units: null,
  volume: null
}
